export default __webpack_public_path__ + "static/media/Monica D. Relda.62240e6a.png";